import { PureLightTheme } from "../../../styles/theme"

export const AvatarButtonStyled = {
  p: 0, 
  '&:hover': {
    backgroundColor: 'transparent',  
  }, 
}

export const AvatarStyled = {
  width: '36px',
  height: '36px',
  [PureLightTheme.breakpoints.down("sm")]: {
    width: "32px",
    height: "32px",
  }
}

export const MenuPaperStyled = {
  width: "250px",
  borderRadius: '12px',
  marginTop: 1,
}

export const MenuListStyled = {
  padding: '12px 0px',
  '& .MuiMenuItem-root': {
    alignSelf: 'start',
    minHeight: "40px",
    height: "40px",
    width: "100%",
    padding: "0px 16px",
    gap: 1,
    fontSize: "14px",
    fontWeight: 400,

    '&:first-of-type': {
      height: '64px', 
      cursor: 'pointer',
      // '&:hover': { backgroundColor: 'transparent' }
    }
  },
}
